<template>
  <teleport to="body">
    <transition name="modal-fotos-anim">
      <div
        v-if="visivel"
        class="overlay-modal-fotos"
        @click.self="fechar"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="modal-fotos-container"
          @click.stop
        >
          <!-- Cabeçalho -->
          <div class="modal-fotos-header">
            <div class="header-info-bloco">
              <div class="icone-cabecalho">
                <i class="ti ti-camera"></i>
              </div>
              <div>
                <h4 class="modal-titulo">
                  {{ isAcao ? "Fotos da Ação" : "Fotos do Encontro" }}
                </h4>
                <p
                  class="modal-subtitulo"
                  v-if="isAcao && tituloAcao"
                >
                  <span class="encontro-nome">{{ tituloAcao }}</span>
                </p>
                <p
                  class="modal-subtitulo"
                  v-else-if="encontro && encontro.titulo"
                >
                  <span class="encontro-nome">{{ encontro.titulo }}</span>
                  <span
                    v-if="encontro.inicio_periodo"
                    class="encontro-data-badge"
                  >
                    <i class="ti ti-calendar-time"></i>
                    {{ formatarData(encontro.inicio_periodo) }}
                  </span>
                </p>
              </div>
            </div>

            <button
              type="button"
              class="btn-fechar-modal"
              @click="fechar"
              aria-label="Fechar modal"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>

          <!-- Corpo do Modal -->
          <div class="modal-fotos-body">
            <!-- SEÇÃO 1: FORMULÁRIO DE ADICIONAR FOTO -->
            <div class="bloco-adicionar-foto" v-if="props.coordenador">
              <div class="bloco-titulo">
                <i class="ti ti-photo-plus"></i>
                <h5>Adicionar Fotos</h5>
                <span
                  v-if="isAcao && arquivosSelecionados.length > 1"
                  class="badge-modo-lote"
                >
                  Modo Lote ({{ arquivosSelecionados.length }} fotos)
                </span>
              </div>

              <div class="form-adicionar-grid">
                <!-- Área de upload / preview -->
                <div class="upload-dropzone-container">
                  <input
                    ref="fileInputRef"
                    type="file"
                    id="input-foto-encontro"
                    accept="image/png, image/jpeg, image/jpg"
                    class="input-file-hidden"
                    :multiple="isAcao"
                    @change="onArquivoSelecionado"
                  />

                  <!-- Preview se uma imagem estiver selecionada -->
                  <div
                    v-if="temFotoSelecionada"
                    class="preview-box"
                  >
                    <!-- Preview múltiplo quando mais de 1 arquivo na Ação -->
                    <div
                      v-if="isAcao && arquivosSelecionados.length > 1"
                      class="multi-preview-grid"
                    >
                      <div
                        v-for="(p, idx) in previews.slice(0, 4)"
                        :key="idx"
                        class="multi-preview-item"
                      >
                        <img :src="p.dataUrl" alt="Miniatura" />
                        <span
                          v-if="idx === 3 && previews.length > 4"
                          class="multi-preview-mais"
                        >
                          +{{ previews.length - 4 }}
                        </span>
                      </div>
                    </div>

                    <!-- Preview único (Encontro ou Ação com 1 foto) -->
                    <img
                      v-else
                      :src="previewUrlExibida"
                      alt="Pré-visualização da imagem"
                    />

                    <button
                      type="button"
                      class="btn-trocar-foto"
                      @click="dispararInputArquivo"
                      title="Alterar imagem selecionada"
                    >
                      <i class="ti ti-refresh"></i> Trocar
                    </button>
                    <button
                      type="button"
                      class="btn-cancelar-selecao"
                      @click="limparSelecao"
                      title="Remover seleção"
                    >
                      <i class="ti ti-x"></i>
                    </button>
                  </div>

                  <!-- Dropzone vazio -->
                  <div
                    v-else
                    class="dropzone-vazio"
                    @click="dispararInputArquivo"
                    @dragover.prevent="dragOver = true"
                    @dragleave.prevent="dragOver = false"
                    @drop.prevent="onDropArquivo"
                    :class="{ 'drag-over': dragOver }"
                  >
                    <div class="dropzone-icone">
                      <i class="ti ti-cloud-upload"></i>
                    </div>
                    <p class="dropzone-texto-principal">
                      <strong>Clique para selecionar</strong> ou arraste a
                      imagem aqui
                    </p>
                    <span class="dropzone-texto-secundario">
                      {{
                        isAcao
                          ? "Suporta envio individual ou em lote (PNG, JPG)"
                          : "Formatos suportados: PNG ou JPG"
                      }}
                    </span>
                  </div>
                </div>

                <!-- Campos de texto e ação -->
                <div class="campos-adicionar-coluna">
                  <div class="campo-grupo">
                    <label
                      for="descricao-foto-input"
                      class="campo-label"
                    >
                      {{
                        isAcao && arquivosSelecionados.length > 1
                          ? "Descrição geral das imagens *"
                          : "Descrição breve da imagem *"
                      }}
                    </label>
                    <div class="input-com-contador">
                      <input
                        type="text"
                        id="descricao-foto-input"
                        class="form-input-descricao"
                        :placeholder="
                          isAcao
                            ? 'Ex.: Alunos e equipe durante atividades práticas'
                            : 'Ex.: Alunos apresentando seus projetos práticos'
                        "
                        v-model="descricaoTexto"
                        maxlength="150"
                        @keyup.enter="adicionarFoto"
                      />
                      <span class="contador-caracteres">
                        {{ descricaoTexto?.length || 0 }}/150
                      </span>
                    </div>
                    <small class="campo-ajuda">
                      {{
                        isAcao && arquivosSelecionados.length > 1
                          ? "Esta descrição será associada às fotos selecionadas no lote."
                          : "Uma frase curta que resuma o momento capturado na fotografia."
                      }}
                    </small>
                  </div>

                  <!-- Seletor de Visibilidade (APENAS PARA ENCONTRO) -->
                  <div
                    v-if="!isAcao"
                    class="campo-grupo"
                  >
                    <label class="campo-label">
                      Visibilidade da foto *
                    </label>
                    <div class="seletor-visibilidade">
                      <button
                        type="button"
                        class="btn-opcao-visibilidade"
                        :class="{ 'ativo': !imagemEncontro.isPublica }"
                        @click="imagemEncontro.isPublica = false"
                      >
                        <i class="ti ti-lock"></i>
                        <span class="opcao-texto">
                          <strong>Privada</strong>
                          <small>Visível apenas para a coordenação</small>
                        </span>
                      </button>

                      <button
                        type="button"
                        class="btn-opcao-visibilidade"
                        :class="{ 'ativo': imagemEncontro.isPublica }"
                        @click="imagemEncontro.isPublica = true"
                      >
                        <i class="ti ti-world"></i>
                        <span class="opcao-texto">
                          <strong>Pública</strong>
                          <small>Visível na página do encontro</small>
                        </span>
                      </button>
                    </div>
                  </div>

                  <div class="acoes-adicionar">
                    <button
                      type="button"
                      class="btn-adicionar-foto"
                      :disabled="
                        !temFotoSelecionada ||
                        !descricaoTexto?.trim() ||
                        isSaving
                      "
                      @click="adicionarFoto"
                    >
                      <i
                        v-if="!isSaving"
                        class="ti ti-plus"
                      ></i>
                      <i
                        v-else
                        class="ti ti-loader icone-girando"
                      ></i>
                      {{
                        isSaving
                          ? "Enviando..."
                          : isAcao
                            ? (arquivosSelecionados.length > 1
                                ? `Adicionar ${arquivosSelecionados.length} Fotos à Ação`
                                : "Adicionar Foto à Ação")
                            : "Adicionar Foto ao Encontro"
                      }}
                    </button>
                  </div>

                  <div
                    v-if="mensagemErro || erro"
                    class="mensagem-erro-inline"
                  >
                    <i class="ti ti-alert-circle"></i> {{ mensagemErro || erro }}
                  </div>
                </div>
              </div>
            </div>

            <!-- SEÇÃO 2: GALERIA DE FOTOS ADICIONADAS -->
            <div class="bloco-galeria-fotos">
              <div class="galeria-cabecalho">
                <div class="galeria-titulo-bloco">
                  <i class="ti ti-photo"></i>
                  <h5>Imagens Adicionadas</h5>
                  <span class="badge-total-fotos">
                    {{ totalElementos }}
                    {{ totalElementos === 1 ? "foto" : "fotos" }}
                  </span>
                </div>
                <span
                  class="galeria-dica"
                  v-if="imagens.length > 0"
                >
                  <i class="ti ti-info-circle"></i> Clique em uma foto para
                  ampliar
                </span>
              </div>

              <!-- Estado de carregamento -->
              <div
                v-if="isLoading"
                class="fotos-carregando"
              >
                <span
                  class="spinner-fotos"
                  aria-hidden="true"
                ></span>
                <p>Carregando fotos...</p>
              </div>

              <!-- Lista / Grid de Fotos -->
              <GaleriaFotosGrid
                v-else-if="imagens.length > 0"
                :itens="imagens"
                :resolver-url="resolverUrlFoto"
                :obter-alt="(foto) => foto.descricao || (isAcao ? 'Foto da ação' : 'Foto do encontro')"
                @abrir="abrirLightbox"
              >
                <!-- Visibilidade apenas para Encontro -->
                <template #badge="{ item: foto }">
                  <span
                    v-if="!isAcao"
                    class="badge-visibilidade-card"
                    :class="foto.isPublica ? 'publica' : 'privada'"
                  >
                    <i :class="foto.isPublica ? 'ti ti-world' : 'ti ti-lock'"></i>
                    {{ foto.isPublica ? "Pública" : "Privada" }}
                  </span>
                </template>

                <!-- Rodapé interativo com data e botão remover -->
                <template #rodape="{ item: foto }">
                  <div class="foto-rodape">
                    <span class="foto-data">
                      <i class="ti ti-calendar"></i>
                      {{ formatarData(foto.dataCriacao || foto.criadoEm || foto.createdAt) || "Registro" }}
                    </span>

                    <button
                      v-if="coordenador"
                      type="button"
                      class="btn-remover-foto-card"
                      @click.stop="confirmarRemover(foto)"
                      title="Remover esta foto"
                    >
                      <i class="ti ti-trash"></i>
                      <span>Remover</span>
                    </button>
                  </div>
                </template>
              </GaleriaFotosGrid>

              <!-- Estado Vazio -->
              <div
                v-else
                class="galeria-vazia"
              >
                <div class="icone-galeria-vazia">
                  <i class="ti ti-photo-off"></i>
                </div>
                <h6>
                  {{
                    isAcao
                      ? "Nenhuma foto cadastrada para esta ação"
                      : "Nenhuma foto cadastrada para este encontro"
                  }}
                </h6>
                <p>
                  {{
                    isAcao
                      ? (coordenador
                          ? "Utilize a seção acima para selecionar e adicionar registros fotográficos desta ação."
                          : "Esta ação ainda não possui registros fotográficos adicionados.")
                      : "Utilize a seção acima para selecionar e adicionar registros fotográficos deste encontro."
                  }}
                </p>
              </div>

              <!-- Paginação -->
              <PaginacaoGex
                v-if="!isLoading && totalElementos > 0"
                :pagina-atual="paginaAtual"
                :total-paginas="totalPaginas"
                :total-elementos="totalElementos"
                :tamanho-pagina="tamanhoPagina"
                @mudar-pagina="mudarPagina"
              />
            </div>
          </div>

          <!-- Rodapé do Modal -->
          <div class="modal-fotos-footer">
            <button
              type="button"
              class="btn-fechar-inferior"
              @click="fechar"
            >
              Fechar
            </button>
          </div>
        </div>

        <!-- LIGHTBOX / VISUALIZAÇÃO AMPLIADA -->
        <GaleriaLightbox
          :foto="fotoLightbox"
          :resolver-url="resolverUrlFoto"
          :obter-data="(f) => (f.dataCriacao || f.criadoEm ? formatarDataHora(f.dataCriacao || f.criadoEm) : '')"
          :pode-alterar-visibilidade="!isAcao && coordenador"
          :alterando-visibilidade="alterandoVisibilidade"
          :pode-remover="coordenador"
          @fechar="fecharLightbox"
          @remover="removerDoLightbox"
          @alterar-visibilidade="alterarVisibilidadeLightbox"
        />
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { formatarData, formatarDataHora } from "@/utils/FormatarEntradas";
import { useEncontroImagem } from "@/composables/useEncontroImagem";
import { useAcaoImagem } from "@/composables/useAcaoImagem";
import { useUploadImagem } from "@/composables/useUploadImagem";
import GaleriaFotosGrid from "@/components/common/GaleriaFotosGrid.vue";
import GaleriaLightbox from "@/components/common/GaleriaLightbox.vue";
import PaginacaoGex from "@/components/common/PaginacaoGex.vue";

const props = defineProps({
  visivel: {
    type: Boolean,
    default: false,
  },
  encontro: {
    type: Object,
    default: () => ({}),
  },
  acaoId: {
    type: [String, Number],
    default: null,
  },
  tituloAcao: {
    type: String,
    default: "",
  },
  tipo: {
    type: String,
    default: "encontro", // 'encontro' | 'acao'
  },
  coordenador: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["fechar", "atualizado"]);

const isAcao = computed(
  () => props.tipo === "acao" || !!props.acaoId
);

const encontroStore = useEncontroImagem();
const acaoStore = useAcaoImagem();
const { preview, processarArquivo, limpar, erro } = useUploadImagem();

const fileInputRef = ref(null);
const imagemEncontro = ref({
  descricao: "",
  isPublica: false,
});
const descricaoTexto = ref("");
const mensagemErro = ref("");
const dragOver = ref(false);
const fotoLightbox = ref(null);
const alterandoVisibilidade = ref(false);

// Suporte a múltiplos arquivos no modo Ação
const arquivosSelecionados = ref([]);
const previews = ref([]);

const EXTENSOES_PERMITIDAS = ["png", "jpg", "jpeg"];

const activeStore = computed(() => (isAcao.value ? acaoStore : encontroStore));
const imagens = computed(() => activeStore.value.imagens.value);
const isLoading = computed(() => activeStore.value.isLoading.value);
const isSaving = computed(() => activeStore.value.isSaving.value);
const pagination = computed(() => activeStore.value.pagination);

const paginaAtual = computed(() => pagination.value.currentPage.value);
const totalPaginas = computed(() => pagination.value.totalPages.value);
const totalElementos = computed(() => pagination.value.totalElements.value);
const tamanhoPagina = computed(() => pagination.value.pageSize.value);

const inicioPagina = computed(() =>
  totalElementos.value ? paginaAtual.value * tamanhoPagina.value + 1 : 0
);

const fimPagina = computed(() =>
  Math.min((paginaAtual.value + 1) * tamanhoPagina.value, totalElementos.value)
);

const temFotoSelecionada = computed(() => {
  if (isAcao.value) {
    return previews.value.length > 0 || !!preview.value;
  }
  return !!preview.value;
});

const previewUrlExibida = computed(() => {
  if (isAcao.value && previews.value.length === 1) {
    return previews.value[0].dataUrl;
  }
  return preview.value;
});

function resolverUrlFoto(foto) {
  if (!foto) return "";
  if (foto.imagemUrl) return foto.imagemUrl;
  if (foto.imagem?.base64Data) {
    return `data:${foto.imagem.mimeType || "image/jpeg"};base64,${foto.imagem.base64Data}`;
  }
  return "";
}

async function mudarPagina(novaPagina) {
  if (
    novaPagina < 0 ||
    novaPagina >= totalPaginas.value ||
    novaPagina === paginaAtual.value
  ) {
    return;
  }
  await carregarFotos(novaPagina);
}

async function carregarFotos(pagina = 0) {
  if (isAcao.value) {
    if (!props.acaoId) {
      acaoStore.imagens.value = [];
      acaoStore.pagination.resetPagination();
      return;
    }
    await acaoStore.fetchImagensByAcao(pagina, 6, props.acaoId);
  } else {
    if (!props.encontro?.encontroId) {
      encontroStore.imagens.value = [];
      encontroStore.pagination.resetPagination();
      return;
    }
    await encontroStore.fetchImagensByEncontro(
      pagina,
      6,
      props.encontro.encontroId,
      !props.coordenador
    );
  }
}

function limparSelecao() {
  limpar();
  imagemEncontro.value = {
    descricao: "",
    isPublica: false,
  };
  descricaoTexto.value = "";
  arquivosSelecionados.value = [];
  previews.value = [];
  mensagemErro.value = "";
  if (fileInputRef.value) {
    fileInputRef.value.value = "";
  }
}

function dispararInputArquivo() {
  fileInputRef.value?.click();
}

function lerArquivoBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve({
        mimeType: file.type || "image/jpeg",
        base64Data: reader.result.split(",")[1],
        dataUrl: reader.result,
        name: file.name,
      });
    };
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

async function onArquivoSelecionado(event) {
  const files = Array.from(event.target?.files || []);
  if (files.length === 0) return;

  if (isAcao.value && files.length > 1) {
    // Processamento múltiplo para Ação
    const validos = files.filter((f) =>
      EXTENSOES_PERMITIDAS.includes(f.name.split(".").pop().toLowerCase())
    );
    if (validos.length > 0) {
      previews.value = await Promise.all(validos.map(lerArquivoBase64));
      arquivosSelecionados.value = previews.value;
    }
  } else {
    // Processamento único padrão
    const file = files[0];
    const processado = await processarArquivo(file);
    if (processado) {
      imagemEncontro.value.imagem = processado;
      arquivosSelecionados.value = [
        {
          mimeType: processado.mimeType,
          base64Data: processado.base64Data,
          dataUrl: preview.value,
        },
      ];
      previews.value = arquivosSelecionados.value;
    }
  }
}

async function onDropArquivo(event) {
  dragOver.value = false;
  const files = Array.from(event.dataTransfer?.files || []);
  if (files.length === 0) return;

  if (isAcao.value && files.length > 1) {
    const validos = files.filter((f) =>
      EXTENSOES_PERMITIDAS.includes(f.name.split(".").pop().toLowerCase())
    );
    if (validos.length > 0) {
      previews.value = await Promise.all(validos.map(lerArquivoBase64));
      arquivosSelecionados.value = previews.value;
    }
  } else {
    const file = files[0];
    const processado = await processarArquivo(file);
    if (processado) {
      imagemEncontro.value.imagem = processado;
      arquivosSelecionados.value = [
        {
          mimeType: processado.mimeType,
          base64Data: processado.base64Data,
          dataUrl: preview.value,
        },
      ];
      previews.value = arquivosSelecionados.value;
    }
  }
}

async function adicionarFoto() {
  if (!temFotoSelecionada.value) {
    mensagemErro.value = "Selecione uma imagem para adicionar.";
    return;
  }

  const desc = descricaoTexto.value.trim();
  if (!desc) {
    mensagemErro.value = "Informe uma descrição breve para a imagem.";
    return;
  }

  try {
    if (isAcao.value) {
      if (arquivosSelecionados.value.length > 1) {
        // Envio em lote
        const lotePayload = arquivosSelecionados.value.map((item) => ({
          descricao: desc,
          imagem: {
            mimeType: item.mimeType,
            base64Data: item.base64Data,
          },
        }));
        await acaoStore.saveLoteImagens(props.acaoId, lotePayload);
      } else {
        // Envio único
        const item = arquivosSelecionados.value[0] || {
          mimeType: imagemEncontro.value.imagem.mimeType,
          base64Data: imagemEncontro.value.imagem.base64Data,
        };
        const payload = {
          descricao: desc,
          imagem: {
            mimeType: item.mimeType,
            base64Data: item.base64Data,
          },
        };
        await acaoStore.saveImagem(props.acaoId, payload);
      }
    } else {
      // Envio do Encontro (com visibilidade)
      imagemEncontro.value.descricao = desc;
      imagemEncontro.value.isPublica = !!imagemEncontro.value.isPublica;
      await encontroStore.saveImagem(
        props.encontro.encontroId,
        imagemEncontro.value
      );
    }

    await carregarFotos(0);
    limparSelecao();
    emit("atualizado", {
      encontroId: props.encontro?.encontroId,
      acaoId: props.acaoId,
      total: totalElementos.value,
    });
  } catch (err) {
    console.error("Erro ao salvar foto:", err);
    mensagemErro.value =
      "Não foi possível adicionar a foto: " +
      (err.response?.data?.message || err.message || "Erro desconhecido.");
  }
}

async function alterarVisibilidadeLightbox(novaVisibilidade) {
  if (
    !fotoLightbox.value ||
    fotoLightbox.value.isPublica === novaVisibilidade
  ) {
    return;
  }

  alterandoVisibilidade.value = true;
  try {
    await encontroStore.modificarVisibilidadeImagem(
      fotoLightbox.value.id,
      novaVisibilidade
    );
    fotoLightbox.value.isPublica = novaVisibilidade;

    const fotoNaLista = imagens.value.find(
      (f) => f.id === fotoLightbox.value.id
    );
    if (fotoNaLista) {
      fotoNaLista.isPublica = novaVisibilidade;
    }

    emit("atualizado", {
      encontroId: props.encontro?.encontroId,
      acaoId: props.acaoId,
      total: totalElementos.value,
    });
  } catch (err) {
    console.error("Erro ao alterar visibilidade:", err);
    alert("Não foi possível alterar a visibilidade da foto.");
  } finally {
    alterandoVisibilidade.value = false;
  }
}

async function confirmarRemover(foto) {
  const fotoId = foto.id || foto.acaoImagemId;
  const confirmar = window.confirm(
    `Deseja realmente remover esta foto?\n\n"${foto.descricao || "Sem descrição"}"`
  );
  if (!confirmar) return;

  try {
    if (isAcao.value) {
      await acaoStore.deleteImagem(fotoId);
    } else {
      await encontroStore.deleteImagem(fotoId);
    }
    const novaPagina =
      imagens.value.length === 1 && paginaAtual.value > 0
        ? paginaAtual.value - 1
        : paginaAtual.value;
    await carregarFotos(novaPagina);
    if (
      (fotoLightbox.value?.id || fotoLightbox.value?.acaoImagemId) === fotoId
    ) {
      fecharLightbox();
    }
    emit("atualizado", {
      encontroId: props.encontro?.encontroId,
      acaoId: props.acaoId,
      total: totalElementos.value,
    });
  } catch (err) {
    console.error("Erro ao remover foto:", err);
    alert("Erro ao remover a foto.");
  }
}

function removerDoLightbox(foto) {
  confirmarRemover(foto);
}

function abrirLightbox(foto) {
  fotoLightbox.value = foto;
}

function fecharLightbox() {
  fotoLightbox.value = null;
}

function fechar() {
  if (fotoLightbox.value) {
    fecharLightbox();
    return;
  }
  emit("fechar");
}

function onKeyDown(e) {
  if (e.key === "Escape") {
    if (fotoLightbox.value) {
      fecharLightbox();
    } else if (props.visivel) {
      fechar();
    }
  }
}

watch(
  () => props.visivel,
  (novo) => {
    if (novo) {
      limparSelecao();
      carregarFotos(0);
    }
  }
);

watch(
  () => props.encontro,
  () => {
    if (props.visivel && !isAcao.value) {
      carregarFotos(0);
    }
  },
  { deep: true }
);

watch(
  () => props.acaoId,
  () => {
    if (props.visivel && isAcao.value) {
      carregarFotos(0);
    }
  }
);

onMounted(() => {
  window.addEventListener("keydown", onKeyDown);
  if (props.visivel) {
    carregarFotos(0);
  }
});

onUnmounted(() => {
  window.removeEventListener("keydown", onKeyDown);
});
</script>

<style scoped>
/* ==================== OVERLAY & CONTAINER ==================== */
.overlay-modal-fotos {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  padding: 20px;
  box-sizing: border-box;
}

.modal-fotos-container {
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  max-width: 900px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  box-shadow:
    0 25px 50px -12px rgba(15, 23, 42, 0.25),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  animation: surgimentoModal 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ==================== CABEÇALHO ==================== */
.modal-fotos-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1.5px solid hsl(258, 25%, 92%);
  background: linear-gradient(135deg, hsl(258, 40%, 98%) 0%, #ffffff 100%);
}

.header-info-bloco {
  display: flex;
  align-items: center;
  gap: 14px;
}

.icone-cabecalho {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background-color: hsl(258, 60%, 94%);
  color: var(--roxo-claro, #6f319e);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  flex-shrink: 0;
}

.modal-titulo {
  font-size: 1.25rem;
  font-weight: 700;
  color: hsl(258, 50%, 20%);
  margin: 0;
  line-height: 1.2;
}

.modal-subtitulo {
  margin: 4px 0 0 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.88rem;
  color: hsl(258, 15%, 45%);
}

.encontro-nome {
  font-weight: 600;
  color: var(--azul-escuro, #1b264f);
}

.encontro-data-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: hsl(258, 30%, 93%);
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: hsl(258, 30%, 30%);
}

.btn-fechar-modal {
  background: transparent;
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: hsl(215, 15%, 50%);
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-fechar-modal:hover {
  background-color: hsl(0, 75%, 95%);
  color: hsl(0, 75%, 45%);
}

/* ==================== CORPO DO MODAL ==================== */
.modal-fotos-body {
  padding: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  flex: 1;
}

.modal-fotos-body::-webkit-scrollbar {
  width: 7px;
}
.modal-fotos-body::-webkit-scrollbar-track {
  background: hsl(258, 20%, 97%);
}
.modal-fotos-body::-webkit-scrollbar-thumb {
  background: hsl(258, 30%, 82%);
  border-radius: 8px;
}
.modal-fotos-body::-webkit-scrollbar-thumb:hover {
  background: var(--roxo-claro, #6f319e);
}

/* ==================== BLOCO 1: ADICIONAR FOTO ==================== */
.bloco-adicionar-foto {
  background: hsl(258, 30%, 98.5%);
  border: 1.5px solid hsl(258, 30%, 91%);
  border-radius: 16px;
  padding: 20px;
}

.bloco-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: var(--roxo-claro, #6f319e);
}

.bloco-titulo i {
  font-size: 1.2rem;
}

.bloco-titulo h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: hsl(258, 45%, 22%);
}

.badge-modo-lote {
  background-color: hsl(258, 60%, 92%);
  color: var(--roxo-primario, #6f319e);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 99px;
  margin-left: 8px;
}

.form-adicionar-grid {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 20px;
  align-items: start;
}

.input-file-hidden {
  display: none;
}

.upload-dropzone-container {
  width: 100%;
  aspect-ratio: 3 / 2;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.dropzone-vazio {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 2px dashed hsl(258, 35%, 85%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.dropzone-vazio:hover,
.dropzone-vazio.drag-over {
  border-color: var(--roxo-claro, #6f319e);
  background-color: hsl(258, 50%, 99%);
  transform: translateY(-1px);
}

.dropzone-icone {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: hsl(258, 45%, 95%);
  color: var(--roxo-claro, #6f319e);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin-bottom: 6px;
}

.dropzone-texto-principal {
  margin: 0;
  font-size: 0.8rem;
  color: hsl(258, 20%, 35%);
  line-height: 1.3;
}

.dropzone-texto-secundario {
  margin-top: 4px;
  font-size: 0.7rem;
  color: hsl(215, 15%, 55%);
}

.preview-box {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid var(--roxo-claro, #6f319e);
  background-color: hsl(258, 15%, 95%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.preview-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.multi-preview-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 3px;
  width: 100%;
  height: 100%;
  padding: 3px;
  box-sizing: border-box;
  background-color: hsl(258, 20%, 92%);
}

.multi-preview-item {
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  width: 100%;
  height: 100%;
}

.multi-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.multi-preview-mais {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.75);
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-trocar-foto {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background-color: rgba(15, 23, 42, 0.8);
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  backdrop-filter: blur(4px);
  transition: background 0.2s;
  z-index: 5;
}

.btn-trocar-foto:hover {
  background-color: rgba(15, 23, 42, 0.95);
}

.btn-cancelar-selecao {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(220, 38, 38, 0.85);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  z-index: 5;
}

.btn-cancelar-selecao:hover {
  background-color: rgb(220, 38, 38);
  transform: scale(1.1);
}

.campos-adicionar-coluna {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.campo-grupo {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.campo-label {
  font-size: 0.86rem;
  font-weight: 600;
  color: hsl(258, 35%, 25%);
}

.input-com-contador {
  position: relative;
  display: flex;
  align-items: center;
}

.form-input-descricao {
  width: 100%;
  padding: 11px 64px 11px 14px;
  border: 1.5px solid hsl(258, 25%, 86%);
  border-radius: 10px;
  font-size: 0.9rem;
  background-color: #ffffff;
  color: hsl(258, 30%, 15%);
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.form-input-descricao:focus {
  outline: none;
  border-color: var(--roxo-claro, #6f319e);
  box-shadow: 0 0 0 3px rgba(111, 49, 158, 0.15);
}

.contador-caracteres {
  position: absolute;
  right: 12px;
  font-size: 0.75rem;
  color: hsl(215, 15%, 55%);
  font-weight: 500;
  pointer-events: none;
}

.campo-ajuda {
  font-size: 0.76rem;
  color: hsl(215, 15%, 50%);
  margin-top: 2px;
}

.acoes-adicionar {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

.btn-adicionar-foto {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: var(--roxo-claro, #6f319e);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(111, 49, 158, 0.25);
}

.btn-adicionar-foto:hover:not(:disabled) {
  background-color: hsl(278, 55%, 38%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(111, 49, 158, 0.35);
}

.btn-adicionar-foto:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.icone-girando {
  animation: girar 1s linear infinite;
}

.mensagem-erro-inline {
  margin-top: 8px;
  font-size: 0.82rem;
  color: #d32f2f;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ==================== BLOCO 2: GALERIA ==================== */
.bloco-galeria-fotos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.galeria-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.galeria-titulo-bloco {
  display: flex;
  align-items: center;
  gap: 8px;
}

.galeria-titulo-bloco i {
  font-size: 1.2rem;
  color: var(--roxo-claro, #6f319e);
}

.galeria-titulo-bloco h5 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: hsl(258, 45%, 22%);
}

.badge-total-fotos {
  background-color: hsl(258, 40%, 93%);
  color: var(--roxo-claro, #6f319e);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 99px;
}

.galeria-dica {
  font-size: 0.8rem;
  color: hsl(215, 15%, 50%);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Itens e rodapé do card da galeria */

.foto-rodape {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid hsl(258, 20%, 93%);
  padding-top: 8px;
}

.foto-data {
  font-size: 0.74rem;
  color: hsl(215, 15%, 55%);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.btn-remover-foto-card {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  color: hsl(0, 75%, 50%);
  border: 1px solid hsl(0, 75%, 88%);
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-remover-foto-card:hover {
  background-color: hsl(0, 80%, 95%);
  border-color: hsl(0, 75%, 65%);
  color: hsl(0, 80%, 35%);
  transform: translateY(-1px);
}

/* Galeria Vazia */
.galeria-vazia {
  background-color: hsl(258, 30%, 98.5%);
  border: 1.5px dashed hsl(258, 25%, 88%);
  border-radius: 14px;
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.icone-galeria-vazia {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: hsl(258, 25%, 92%);
  color: hsl(258, 20%, 65%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  margin-bottom: 4px;
}

.galeria-vazia h6 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 600;
  color: hsl(258, 30%, 30%);
}

.galeria-vazia p {
  margin: 0;
  font-size: 0.85rem;
  color: hsl(215, 15%, 52%);
  max-width: 420px;
}

/* ==================== ESTADO DE CARREGAMENTO ==================== */
.fotos-carregando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 12px;
  color: hsl(258, 20%, 45%);
  font-size: 0.88rem;
}

.spinner-fotos {
  width: 32px;
  height: 32px;
  border: 3px solid hsl(258, 30%, 90%);
  border-top-color: var(--roxo-claro, #6f319e);
  border-radius: 50%;
  animation: girar 0.8s linear infinite;
}

/* ==================== RODAPÉ DO MODAL ==================== */
.modal-fotos-footer {
  padding: 16px 24px;
  border-top: 1.5px solid hsl(258, 25%, 92%);
  display: flex;
  justify-content: flex-end;
  background-color: #ffffff;
}

.btn-fechar-inferior {
  padding: 8px 22px;
  background-color: hsl(215, 18%, 93%);
  color: hsl(215, 25%, 25%);
  border: 1px solid hsl(215, 20%, 85%);
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-fechar-inferior:hover {
  background-color: hsl(215, 20%, 88%);
  color: hsl(215, 30%, 15%);
}



/* ==================== ANIMAÇÕES ==================== */
@keyframes girar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: girar 0.9s linear infinite;
}

/* Seletor de Visibilidade no Cadastro */
.seletor-visibilidade {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.btn-opcao-visibilidade {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background-color: #ffffff;
  border: 1.5px solid hsl(258, 25%, 86%);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: hsl(258, 20%, 35%);
}

.btn-opcao-visibilidade i {
  font-size: 1.25rem;
  color: hsl(258, 20%, 55%);
  transition: color 0.2s;
  flex-shrink: 0;
}

.opcao-texto {
  display: flex;
  flex-direction: column;
}

.opcao-texto strong {
  font-size: 0.84rem;
  color: hsl(258, 45%, 22%);
}

.opcao-texto small {
  font-size: 0.7rem;
  color: hsl(215, 15%, 55%);
}

.btn-opcao-visibilidade:hover {
  border-color: var(--roxo-claro, #6f319e);
  background-color: hsl(258, 40%, 98%);
}

.btn-opcao-visibilidade.ativo {
  background-color: hsl(258, 50%, 96%);
  border-color: var(--roxo-claro, #6f319e);
  box-shadow: 0 0 0 1px var(--roxo-claro, #6f319e);
}

.btn-opcao-visibilidade.ativo i {
  color: var(--roxo-claro, #6f319e);
}

.btn-opcao-visibilidade.ativo .opcao-texto strong {
  color: var(--roxo-claro, #6f319e);
}

/* Badge de Visibilidade no Card da Galeria */
.badge-visibilidade-card {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  backdrop-filter: blur(4px);
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.badge-visibilidade-card.publica {
  background-color: rgba(16, 185, 129, 0.9);
  color: #ffffff;
}

.badge-visibilidade-card.privada {
  background-color: rgba(15, 23, 42, 0.85);
  color: #f1f5f9;
}


@keyframes surgimentoModal {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-fotos-anim-enter-active,
.modal-fotos-anim-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fotos-anim-enter-from,
.modal-fotos-anim-leave-to {
  opacity: 0;
}



/* ==================== RESPONSIVIDADE ==================== */
@media (max-width: 768px) {
  .modal-fotos-container {
    max-height: 96vh;
    border-radius: 14px;
  }

  .form-adicionar-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .upload-dropzone-container {
    min-height: 140px;
  }

  .grid-fotos-encontro {
    grid-template-columns: 1fr;
  }
}
</style>
